const historyTotals = (history: any) => {
  let invoice_value: any = 0;
  let cost: any = 0;
  let net: any = 0;
  let gp: any = 0;
  history.forEach((service: any) => {
    invoice_value = invoice_value + service.invoice_value;
    cost = cost + service.cost;
    net = net + service.net;
    gp = gp + service.gp;
  });

  return { invoice_value, cost, net, gp };
};

export default historyTotals;
